import React from 'react';
import Nav from 'react-bootstrap/Nav';
import { Link, useLocation } from 'react-router-dom';
import { PRODUCTION_PANEL_SHOP_TAB_ROUTES } from '../../config/productionRoutes';
import './PanelShopNav.css';

const PanelShopNav = () => {
  const { pathname } = useLocation();
  const activePath = pathname.replace(/\/+$/, '').toLowerCase();

  return (
    <div className="modern-nav-container">
      <Nav as="nav" aria-label="Panel Shop" variant="tabs" activeKey={activePath} className="modern-nav panel-shop-nav">
        <Nav.Item>
          <Nav.Link as={Link} to="/" className="modern-nav-link home-nav-link">
            <i className="bi bi-house-fill me-2" aria-hidden="true" />
            Home
          </Nav.Link>
        </Nav.Item>
        {PRODUCTION_PANEL_SHOP_TAB_ROUTES.map(({ id, label, path }) => (
          <Nav.Item key={id}>
            <Nav.Link as={Link} to={path} eventKey={path} className="modern-nav-link" aria-current={activePath === path ? 'page' : undefined}>
              {label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default PanelShopNav;
